import { css } from '@emotion/react';
import { ordered } from '@tablecheck/locales';
import {
  LanguageSelector as LanguageSelectorTK,
  View
} from '@tablekit/language-selector';
import * as React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useWindowSize } from 'react-use';

import {
  GrowWrapper,
  LangIcon,
  LangText,
  LanguageSelectorWrapper
} from 'components/MainLayout/styled';
import { getI18nextInstance } from 'i18n';
import { BREAKPOINTS, SUPPORTED_LOCALES } from 'utils/constants';
import { Params } from 'utils/types';

export function LanguageSelector({
  isDark
}: {
  isDark?: boolean;
}): JSX.Element {
  const i18next = getI18nextInstance();
  const params = useParams<Params>();
  const { pathname, search } = useLocation();
  const history = useHistory();
  const { width } = useWindowSize();
  const isTablet = width <= parseInt(BREAKPOINTS.tablet, 10);

  return (
    <LanguageSelectorWrapper>
      <LanguageSelectorTK
        shouldShowCloseIcon
        view={isTablet ? View.Mobile : View.Desktop}
        itemWidth={isTablet ? '100%' : '50%'}
        containerCss={
          isTablet
            ? css`
                width: 100%;
              `
            : undefined
        }
        currentLanguage={params.locale}
        locales={ordered}
        renderTrigger={({ onClick, ref }) => (
          <GrowWrapper
            onClick={onClick}
            ref={ref}
            className="animated slideInRight delay-01s fast"
            data-theme={isDark ? 'light' : 'dark'}
          >
            <LangText>{params.locale?.slice(-2)}</LangText>
            <LangIcon size={28} />
          </GrowWrapper>
        )}
        onChangeLanguage={(locale: string) => {
          const newPathname = pathname.replace(
            new RegExp(`^/(${SUPPORTED_LOCALES.join('|')})(.*)`),
            `/${locale}$2`
          );
          history.push(`${newPathname}${search}`);
          i18next.changeLanguage(locale);
        }}
      />
    </LanguageSelectorWrapper>
  );
}
